import { render, staticRenderFns } from "./InformationsAttributes.vue?vue&type=template&id=5d58294b&scoped=true&"
import script from "./InformationsAttributes.vue?vue&type=script&lang=js&"
export * from "./InformationsAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d58294b",
  null
  
)

export default component.exports